exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#message .input_search .ic_search{\n  position: absolute;\n  left: 25px;\n  top: 11px;\n  font-size: 12px;\n  color: #9e9e9e;\n}\n\n#message .navbar-form .form-control {\n  width: 360px;\n}\n\ni.cursor_pointer {\n  cursor: pointer;\n}\n\n#message .input_search input{\n  padding-left: 25px;\n}\n\n#message .slc_sm{\n  width: 360px;\n}\n\n#message .btn-send-msg{\n  background-color: #5b6c72;\n  color: #fff;\n  border-color: #5b6c72;\n}\n\n#message .card{\n    border: 1px solid #dadada;\n    padding: 20px 40px;\n    margin-top: 25px;\n    border-radius: 4px;\n    background-color: #fff;\n\n}\n\n#message .body{\n    width: 831px;\n    height: 680px;\n    margin-left: 20px;\n    margin-bottom: 30px;\n}\n\n#message .ic_avatar{\n  display: inline-block;\n  float: left;\n  margin-top: 2px;\n  border: 1px solid #fff;\n  border-radius: 50%;\n}\n\n#message .tr_bg{\n  /* background-color: #f8fae5; */\n  border-top: 7px solid #fff;\n}\n\n#message td{\n  padding-right: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/message/message.component.css
// module id = ../../../../../src/app/pages/message/message.component.css
// module chunks = main